export default "__VITE_ASSET__DcNy9Pij__"